import type { ToastState } from './_state.type';

/** Toast State. */
export const toastState: ToastState = {
  toast: {
    states: {},
  },
};
